import { ReportServices } from "../../base/service/apiServices";
import { dashBoardSliceActions } from "../slices/dashboard_slice/dashBoard";
import moment from "moment";
export const getDashboardCallData = (data: any, dispatch: any) => {
  const body: any = {
    startTmpstmp: data.fromDate,
    endTmpstmp: data.toDate,
    timezone: "",
  };

  ReportServices.post(body, "/get_call_live_dashboard_piechart").then((response: any) => {
    dispatch(
      dashBoardSliceActions.callsData({
        dashBoardCallData: response.data.getQueueInboundCallRes,
      })
    );
  });
};

export const getDashboardCallDatalive = (dispatch: any) => {
  const body: any = {
    startTmpstmp: moment().startOf('day').valueOf(),
    endTmpstmp: moment().endOf('day').valueOf(),
    channelType: 'Call',
    timeZone: ''
  };

  ReportServices.post(body, "/get_call_live_dashboard_piechart").then((response: any) => {
    dispatch(
      dashBoardSliceActions.callsData({
        dashBoardCallData: response.data.getCallLiveDashboardDetails,
      })
    );
  });
};

export const getDashboardEmailDatalive = (dispatch: any) => {
  const body: any = {
    startTmpstmp: moment().startOf('day').valueOf(),
    endTmpstmp: moment().endOf('day').valueOf(),
    channelType: 'Call',
    timeZone: ''
  };

  ReportServices.post(body, "/get_email_live_dashboard_piechart").then((response: any) => {
    dispatch(
      dashBoardSliceActions.emailData({
        dashBoardEmailData: response.data.getChatLiveDashboardDetails,
      })
    );
  });
};

export const getDashboardSmsDatalive = (dispatch: any) => {
  const body: any = {
    startTmpstmp: moment().startOf('day').valueOf(),
    endTmpstmp: moment().endOf('day').valueOf(),
    channelType: 'Call',
    timeZone: ''
  };

  ReportServices.post(body, "/get_sms_live_dashboard_piechart").then((response: any) => {
    dispatch(
      dashBoardSliceActions.smsData({
        dashBoardSmsData: response.data.getChatLiveDashboardDetails,
      })
    );
  });
};

export const getDashboardSocialmediaDatalive = (dispatch: any) => {
  const body: any = {
    startTmpstmp: moment().startOf('day').valueOf(),
    endTmpstmp: moment().endOf('day').valueOf(),
    channelType: 'Call',
    timeZone: ''
  };
  

  ReportServices.post(body, "/get_dashboard_social_media_status").then((response: any) => {
    dispatch(
      dashBoardSliceActions.socialData({
        dashBoardSocialData: response.data.getChatLiveDashboardDetails,
      })
    );
  });
};